// extracted by mini-css-extract-plugin
export default {"avatar":"avatar---fYbfR","placeholder":"placeholder---c1eZB"};